<template>
<router-view />
</template>

<script>
export default {
  name: 'PMFAnalysisPMRun',
  routeInfo: {
    label: '颗粒物'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/11PMF-Analysis/01PM/index.vue